import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, ModuleFE_MouseInteractivity } from '@nu-art/thunderstorm-frontend/index';
import { InboxFilters, InboxFilters_LabelMap } from '@app/advisor-v5-shared';
import './Inbox_Filtering.scss';
import { ICONS } from '@app/styles';
import { Inbox_FilterMenu } from './Inbox_FilterMenu.js';
import { ModuleFE_Inbox } from '../../modules/module-inbox/ModuleFE_Inbox.js';
export class Inbox_Filtering extends ComponentSync {
    //######################### Life Cycle #########################
    __onInboxFiltersUpdated = () => this.reDeriveState();
    deriveStateFromProps(nextProps, state) {
        state.activeFilters = ModuleFE_Inbox.activeFilters.get();
        state.variant = nextProps.variant ?? 'full';
        state.mini = !!nextProps.mini;
        return state;
    }
    //######################### Logic #########################
    getButtonText = () => {
        const filters = this.state.activeFilters;
        //If no filters or all filters are marked
        if (!filters.length || filters.length === InboxFilters.length)
            return 'All Tasks';
        return this.state.activeFilters.map(filter => InboxFilters_LabelMap[filter]).join(', ');
    };
    openFilterMenu = (e) => {
        const box = e.currentTarget.getBoundingClientRect();
        const model = {
            content: () => _jsx(Inbox_FilterMenu, {}),
            id: 'pop-up__inbox-filter-menu',
            modalPos: this.state.mini ? { x: -1, y: 1 } : { x: 1, y: 1 },
            originPos: this.state.mini ? { x: box.right, y: box.y } : { x: box.x, y: box.y },
            xAxisAnchor: this.state.mini ? 'right' : 'left',
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    //######################### Render #########################
    render() {
        return _jsxs(Button, { id: 'inbox-filters-button', variant: 'header-button', onClick: this.openFilterMenu, children: [this.renderContent_Full(), this.renderContent_Concise()] });
    }
    renderContent_Full = () => {
        if (this.state.variant !== 'full')
            return;
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'inbox-filters-button__text', children: this.getButtonText() }), _jsx(ICONS.advisor_v4_arrow.component, { className: 'arrow-icon' })] });
    };
    renderContent_Concise = () => {
        if (this.state.variant !== 'concise')
            return;
        return _jsx(ICONS.advisor_avn_filter.component, {});
    };
}
//# sourceMappingURL=Inbox_Filtering.js.map